module.exports = __webpack_public_path__ + "img/warning.ac588d80.svg";